import React, { useState } from "react";
import { connect } from "react-redux";
import { createStore } from "devextreme-aspnet-data-nojquery";
import ItemSearchFormResult from "../maintabs/item/ItemSearchFormResult";
import ItemSearchForm from "../maintabs/item/ItemSearchForm";

const WMItemDetailsWithCustomer = (props) => {
    const orderStatus = "0";
    const getDataUrl = "wm/TransactionManagement/GetAllItems";
    const [dataSource, setDataSource] = useState(null);
    const [pageTitle, setPageTitle] = useState("Items");
    const accessToken = props.oidc.user.access_token;

    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: "rowId",
            loadParams: {
                itemCode: () => formFields.itemCode,
                itemDescription1: () => formFields.itemDescription1,
                RCustomer: () => formFields.R_CUSTOMER,
                customerName: () => formFields.customerName,
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };

    const searchData = (formFields) => {
        const resultData = GetGridData(accessToken, getDataUrl, formFields);
        setDataSource(resultData);
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <ItemSearchForm pageTitle={pageTitle} searchData={searchData} />
                        <ItemSearchFormResult data={dataSource} itemTabColoring={props.itemTabColoring} />
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMItemDetailsWithCustomer);
